import { Pipe, PipeTransform } from '@angular/core';
import { IProtoAddress } from '../models/common';
import { Address } from '@lsq-frontend/remote-services/enterprise/common';

// TODO(dmayer): remove the keys with underscores once we figure out the improper camelCasing bug in protobuf-js.
@Pipe({
    name: 'address'
})
export class AddressPipe implements PipeTransform {
    public transform(address: Partial<Address & IProtoAddress>, includeCountry = false): string {
        let addressStr = '';

        if (!address || Object.keys(address).every((key) => !address[key])) {
            return '';
        }

        if (address.address1) {
            addressStr += `${address.address1}`;
        } else if (address.streetLine_1) {
            addressStr += `${address.streetLine_1}`;
        } else if (address.streetLine1) {
            addressStr += `${address.streetLine1}`;
        } else if (address.street) {
            addressStr += `${address.street}`;
        }

        if (address.address2) {
            addressStr += ` ${address.address2}`;
        } else if (address.streetLine_2) {
            addressStr += ` ${address.streetLine_2}`;
        } else if (address.streetLine2) {
            addressStr += ` ${address.streetLine2}`;
        }

        if (address.streetLine_3) {
            addressStr += `${address.streetLine_3}`;
        } else if (address.streetLine3) {
            addressStr += `${address.streetLine3}`;
        }

        if (address.city) {
            if (addressStr.trim().length) {
                addressStr += `, ${address.city}`;
            } else {
                addressStr += `${address.city}`;
            }
        }

        if (address.state) {
            if (addressStr.trim().length) {
                addressStr += `, ${address.state}`;
            } else {
                addressStr += `${address.state}`;
            }
        }

        if (address.country && includeCountry) {
            if (addressStr.trim().length) {
                addressStr += `, ${address.country}`;
            } else {
                addressStr += `${address.country}`;
            }
        }

        if (address.postalCode) {
            addressStr += ` ${address.postalCode}`;
        } else if (address.zipCode) {
            addressStr += ` ${address.zipCode}`;
        }

        return addressStr;
    }
}
